import { Injectable } from '@angular/core';
import { CampaignService } from '../campaign.service';

/* RxJs */
import { Observable, of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';

/* NgRx */
import * as expiredCampaignActions from './expired-campaign.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { CampaignListTab } from '../campaign';

@Injectable()
export class ExpiredCampaignEffects {
    constructor(private _campaignService: CampaignService,
        private _actions$: Actions) { }

    @Effect()
    loadExpiredCampaignSummaries$: Observable<Action> = this._actions$.pipe(
        ofType(expiredCampaignActions.ExpiredCampaignActionTypes.loadCampaigns),
        map((action: expiredCampaignActions.LoadCampaigns) => action.payload),
        mergeMap((requestInfo) =>
            this._campaignService.getCampaigns(CampaignListTab.expired,
                    requestInfo.pagination.index, requestInfo.pagination.size,
                    requestInfo.sorting.fieldName, requestInfo.sorting.direction).pipe(
                map(campaigns => (new expiredCampaignActions.LoadCampaignsSuccess(campaigns))),
                catchError(err => of(new expiredCampaignActions.LoadCampaignsFail('Error laoding expired campaigns')))
            )
        )
    );
}
